import React from 'react'
import { IconsModel } from './types/iconsModel'

const SvgRightArrowNoBar = (
	{
		color,
		width = 7,
		height = 10,
		...props
	}: IconsModel
) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 7 10" {...props}>
		<path id="Tracé_641" data-name="Tracé 641" d="M0,0,3.492,3.5,6.911,0" transform="translate(1.414 8.325) rotate(-90)" fill="none" stroke={color} strokeLinecap="round" strokeWidth="2"/>
	</svg>

)

export default SvgRightArrowNoBar
